SCM = SCM || {};

SCM.SearchAccessibility = (function ($) {
    return {
        init: _init,
        setTaxonomyArrowState: _setTaxonomyArrowState
    }

    var currentOptionIndex = -1;
    var facetIndex = 0;

    function _init() {
        if (!_myComponentIsOnPage()) {
            return;
        }
        facetIndex = 0;
        currentOptionIndex = -1;
        _bindEvents();
    }

    function _myComponentIsOnPage() {
        return $('.pg_searchresults, .js-nbnj-left-rail, .js-alerts-sign-up-wrapper, .js-journals-alerts-sign-up-wrapper, .js-content-alert-modal').find('.js-facet-accessibility, .js-taxonomy-facet-accessibility, .taxonomy-node').length
            || $('.js-alerts-sign-up-wrapper').length;
    }

    function _bindEvents() {
        // Non-taxonomy facets (collections, bookparttitle, publication date, etc.) keep the
        // listbox/tree keyboard pattern. The taxonomy tree now uses a disclosure pattern —
        // see _bindTaxonomyDisclosureEvents below.
        $(document).on('keydown', '.js-facet-accessibility', function (e) {
            const $parentFacetList = $(this);
            const isTreeFacet = $parentFacetList.find('ul.collections-child-list,ul.bookparttitle-child-list');

            // Get just the visible facet options to work with
            const $facetOptions = $parentFacetList.children('li:visible');

            // Initially reset focus so that there's no weird behavior
            _resetFocus($facetOptions, $parentFacetList);

            var facetObjList = _createFacetList($parentFacetList);

            facetIndex = 0;

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    _handleArrowDownUpKeyForFacetList(facetObjList, 'forward');
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    _handleArrowDownUpKeyForFacetList(facetObjList, 'backward');
                    break;
                case 'ArrowRight':
                    e.preventDefault();
                    if (!isTreeFacet) {
                        // This keydown is used for the tree facets
                        return;
                    }
                    _handleArrowRightKeyForFacetList(facetObjList);
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    // This keydown is used for the tree facets
                    if (!isTreeFacet) {
                        return;
                    }
                    _handleArrowLeftKeyForFacetList(facetObjList);
                    break;
                case 'Tab':
                    currentOptionIndex = -1;
                    break;
                case ' ': // Space
                    e.preventDefault();
                    _handleSpaceKeyForFacetList(facetObjList);
                    break;
                case 'Enter':
                    e.preventDefault();
                    let $enteredElement = $(e.target);
                    _handleEnterKeyForFacetList(facetObjList, $parentFacetList, $enteredElement);
                    break;
            }
        });

        _bindTaxonomyDisclosureEvents();
    }

    // Disclosure-pattern wiring for the taxonomy facet expand buttons.
    // The <button> is a normal tab stop; Enter/Space activate it natively via click.
    // Esc collapses the enclosing expanded facet and returns focus to its arrow.
    function _bindTaxonomyDisclosureEvents() {
        // Contract: .js-taxonomy-parent-arrow must render inside a .taxonomy-node ancestor.
        // The wrapper scope keeps this handler from binding to any unrelated future use
        // of the js- hook outside the taxonomy facet structure. All four templates that
        // emit the arrow today (TaxonomyFilterNode, TaxonomyTreeWithCheckbox,
        // TaxonomyFilterModal, SeriesTaxonomyFilterModal) honor this.
        $(document).on('click', '.taxonomy-node .js-taxonomy-parent-arrow', function () {
            _toggleTaxonomyArrow($(this));
        });

        $(document).on('keydown', '.taxonomy-node', function (e) {
            if (e.key !== 'Escape') {
                return;
            }
            var $arrow = _findExpandedAncestorArrow($(e.target));
            if (!$arrow.length) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            _setTaxonomyArrowState($arrow, false);
            $arrow.trigger('focus');
        });
    }

    function _toggleTaxonomyArrow($arrow) {
        var wasExpanded = $arrow.attr('data-expanded') === 'true';
        _setTaxonomyArrowState($arrow, !wasExpanded);
    }

    // The single writer of disclosure state. Writes in priority order: canonical store
    // first (data-expanded on the button), then the a11y reflection (aria-expanded),
    // then the DOM visibility (.hide), then the visual reflections (icon, SR text).
    // Public on SCM.SearchAccessibility so client handlers (e.g. OUP) can drive this
    // instead of mutating .hide / aria themselves.
    function _setTaxonomyArrowState($arrow, expanded) {
        var $childList = _getControlledList($arrow);
        if (!$childList.length) {
            return;
        }

        $arrow.attr('data-expanded', expanded ? 'true' : 'false');
        $arrow.attr('aria-expanded', expanded ? 'true' : 'false');
        $childList.toggleClass('hide', !expanded);

        var $icon = $arrow.find('.js-taxonomy-icon');
        $icon.toggleClass('icon-general-arrow-filled-down', expanded);
        $icon.toggleClass('icon-general-arrow-filled-right', !expanded);

        var $srText = $arrow.find('.screenreader-text');
        if ($srText.length) {
            var labelText = ($childList.attr('aria-label') || '').trim();
            var prefix = expanded ? 'Collapse' : 'Expand';
            $srText.text(labelText ? prefix + ' ' + labelText : prefix);
        }
    }

    function _getControlledList($arrow) {
        return $arrow.closest('.js-taxonomy-label-wrap')
                     .siblings('.js-taxonomy-child-list')
                     .first();
    }

    function _findExpandedAncestorArrow($from) {
        if ($from.is('.js-taxonomy-parent-arrow') && $from.attr('data-expanded') === 'true') {
            return $from;
        }
        // The nearest visible (not .hide) ancestor child list is the one to collapse;
        // its controlling arrow is in the sibling label-wrap.
        var $childList = $from.closest('.js-taxonomy-child-list:not(.js-taxonomy-facet-accessibility):not(.hide)');
        if (!$childList.length) {
            return $();
        }
        return $childList.siblings('.js-taxonomy-label-wrap')
                         .find('.js-taxonomy-parent-arrow')
                         .first();
    }

    function _createFacetList($parentElement, parentElementId, facetObjList) {
        var facetObjList = facetObjList || [];
        parentElementId = (typeof parentElementId === 'undefined') ? -1 : parentElementId;

        $parentElement.children('li:visible').each(function () {
            var $li = $(this);

            if ($li) {
                if ($li.hasClass('facetMoreLess')) {
                    $li.find('button').each(function () {
                        facetObjList.push({
                            id: facetIndex++,
                            element: $(this),
                            parentId: parentElementId
                        });
                    });
                }
                else if ($li.find('a').hasClass('facetShowMore')) {
                    $li.find('a').each(function () {
                        facetObjList.push({
                            id: facetIndex++,
                            element: $(this),
                            parentId: parentElementId
                        });
                    });
                }
                else {
                    facetObjList.push({
                        id: facetIndex++,
                        element: $li,
                        parentId: parentElementId
                    });
                }

                let $childUl = $li.find('ul.collections-child-list').first();
                if ($childUl.length) {
                    _createFacetList($childUl, (facetIndex - 1), facetObjList);
                }

                $childUl = $li.find('ul.bookparttitle-child-list').first();
                if ($childUl.length) {
                    _createFacetList($childUl, (facetIndex - 1), facetObjList);
                }

                let $siblingUl = $li.siblings('.sf-facet-list');
                if ($siblingUl.length) {
                    _createFacetList($siblingUl, (facetIndex - 1), facetObjList);
                }
            }
        });

        return facetObjList;
    }

    function _createFacetListForTree($parentElement, parentElementId, facetObjList) {
        // Ensure the facetObjList is initiliazed if not provided
        facetObjList = facetObjList || [];
        parentElementId = (typeof parentElementId === 'undefined') ? -1 : parentElementId;

        // Iterate over each 'li' element within the parent 'ul'
        $parentElement.children('li:visible').each(function () {
            var $li = $(this);

            // Look for an anchor tag with the class 'js-taxonomy-label'
            var $anchor = $li.find('a.js-taxonomy-label,label.js-taxonomy-label').first();
            if ($anchor.length) {
                facetObjList.push({
                    id: facetIndex++,
                    element: $anchor,
                    parentId: parentElementId
                });
            }

            // If the 'li' element has a class of 'facetMoreLess' 
            if ($li.hasClass('facetMoreLess')) {
                $li.find('button').each(function () {
                    facetObjList.push({
                        id: facetIndex++,
                        element: $(this),
                        parentId: parentElementId
                    });
                });
            }
            else if ($li.find('a').hasClass('facetShowMore')) {
                $li.find('a').each(function () {
                    facetObjList.push({
                        id: facetIndex++,
                        element: $(this),
                        parentId: parentElementId
                    });
                });
            }

            // Look for any child 'ul' elements with class 'js-taxonomy-child-list'
            var $childUl = $li.children('ul.js-taxonomy-child-list');
            if ($childUl.length) {
                // Recursively call the function for the child 'ul'
                _createFacetListForTree($childUl, (facetIndex - 1), facetObjList);
            }
        });

        return facetObjList;
    }

    function _resetFocus($items, $parentFacetList) {
        // If the parent facet list is in focus, reset the currentOptionIndex
        if ($parentFacetList.is(':focus')) {
            currentOptionIndex = -1;
        }

        $items.removeAttr('tabindex');
        $items.find('.js-pub-label,.js-focus-element').attr('tabindex', -1);
        $items.find('button').attr('tabindex', -1);
        $items.find('a.js-focus-element,label.js-focus-element').attr('tabindex', -1);

        // This handles resetting the focus on the availability filters as they are structured differently.
        $items.find('.js-availability-label').removeAttr('tabindex');
        $('.sf-facet-list').children('.sf-facet-child').find('.js-availability-label').removeAttr('tabindex');
    }

    function _handleArrowDownUpKeyForFacetList(facetObjList, direction) {
        currentOptionIndex = _getCurrentOptionIndexForFacetList(facetObjList, currentOptionIndex, direction);

        let currentFacetItem = _getFacetItemById(facetObjList, currentOptionIndex)
        let $currentFacetItemElement = currentFacetItem.element;


        // Determine what type of element we need to focus on and move 
        // the focus to that element (i.e., button or checkbox)
        let $elementToFocus = _getFocusableElement($currentFacetItemElement);
        _updateFocus($elementToFocus.first());
    }

    function _handleArrowRightKeyForFacetList(facetObjList) {
        let currentFacetItem = _getFacetItemById(facetObjList, currentOptionIndex);
        if (!currentFacetItem) {
            return
        };
        let $currentFacetItemElement = currentFacetItem.element;

        let $parentLiItem = $currentFacetItemElement.closest('.js-taxonomy-child-list-item,.js-collection-child-list-item,.js-bookparttitle-child-list-item');
        let $expandableFacetList = $parentLiItem.find('ul.js-taxonomy-child-list,ul.collections-child-list,ul.bookparttitle-child-list').first();
        let $expandableFacetIcon = $parentLiItem.find('.js-taxonomy-icon,.js-collection-arrow-icon,.js-bookparttitle-arrow-icon').first();

        if ($expandableFacetIcon.hasClass('icon-general-arrow-filled-right')) {
            $expandableFacetIcon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
            let $screenReaderText = $expandableFacetIcon.find('.screenreader-text');
            $screenReaderText.text('Collapse');
        }
        $expandableFacetList.removeClass('hide');
        let $input = $parentLiItem.find('.js-taxonomy-label, .js-collection-checkbox, .js-bookparttitle-checkbox').first();
        if ($input.length) {
            $input.attr('aria-expanded', 'true');
        }
    }

    function _handleArrowLeftKeyForFacetList(facetObjList) {
        let currentFacetItem = _getFacetItemById(facetObjList, currentOptionIndex);

        // Checking if current or parent facet items are undefined or if parent facet item is the first one.
        // If true then we return doing nothing so we don't accidentally hide the top level facet list.
        if (!currentFacetItem) {
            return
        };
        let $currentFacetItemElement = currentFacetItem.element;
        let $parentLiItem = $currentFacetItemElement.closest('.js-taxonomy-child-list-item,.js-collection-child-list-item,.js-bookparttitle-child-list-item');
        let $expandableFacetList = $parentLiItem.find('ul.js-taxonomy-child-list,ul.collections-child-list,ul.bookparttitle-child-list').first();
        let $expandableFacetIcon = $parentLiItem.find('.js-taxonomy-icon,.js-collection-arrow-icon,.js-bookparttitle-arrow-icon').first();
        let $screenReaderText = $expandableFacetIcon.find('.screenreader-text');

        let isFacetMoreLess = $currentFacetItemElement.is('button');

        if (!isFacetMoreLess && $expandableFacetIcon.hasClass('icon-general-arrow-filled-down')) {
            // Handles when you are on an item with an arrow
            $expandableFacetIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right')
            $screenReaderText.text('Expand');
            $expandableFacetList.addClass('hide');

            let $input = $parentLiItem.find('a.js-taxonomy-label, .js-taxonomy-checkbox, .js-collection-checkbox, .js-bookparttitle-checkbox');
            $input.attr('aria-expanded', 'false');
        } else {
            let parentFacetItem = _getFacetItemById(facetObjList, currentFacetItem.parentId);

            if (typeof parentFacetItem === 'undefined') {
                return;
            }
            let $parentFacetItemElement = parentFacetItem.element;

            // Handles when you are on a link with now arrow and the shore more less buttons
            let $parentFacetList = $currentFacetItemElement.closest('.js-taxonomy-child-list,.collections-child-list,.bookparttitle-child-list');
            $parentLiItem = $parentFacetList.closest('.js-taxonomy-child-list-item,.js-collection-child-list-item,.js-bookparttitle-child-list-item');
            $expandableFacetIcon = $parentLiItem.find('.js-taxonomy-icon,.js-collection-arrow-icon,.js-bookparttitle-arrow-icon');
            $parentFacetList.addClass('hide');

            let $input = $parentLiItem.find('a.js-taxonomy-label, .js-taxonomy-checkbox, .js-collection-checkbox, .js-bookparttitle-checkbox');
            $input.attr('aria-expanded', 'false');

            if ($expandableFacetIcon.hasClass('icon-general-arrow-filled-down')) {
                $expandableFacetIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
                $screenReaderText.text('Expand');
            }

            let $elementToFocus = _getFocusableElement($parentFacetItemElement);
            _updateFocus($elementToFocus.first());

            // Making sure to set the current index to the parent Id so that when using arrow keys we are navigating to the correct items.
            currentOptionIndex = parentFacetItem.id
        }
    }

    function _handleEnterKeyForFacetList(facetObjList, $parentFacetList, $enteredElement) {
        let currentFacetItem = _getFacetItemById(facetObjList, currentOptionIndex)

        if (!currentFacetItem) {
            // check if it's a 'show more/less' facet.
            if ($enteredElement.is('a.facetShowMore')) {
                $enteredElement.click();
                let $parentFacetElement = $enteredElement.closest('ul.js-facet-accessibility');
                if ($parentFacetElement.length) {
                    _updateFocus($parentFacetElement);
                }
            }
            return
        };

        let $currentFacetItemElement = currentFacetItem.element;

        let parentFacetItem = _getFacetItemById(facetObjList, currentFacetItem.parentId);
        $parentFacetList = (typeof parentFacetItem !== 'undefined') ? parentFacetItem.element : $parentFacetList;

        if ($currentFacetItemElement.is('.facetShowMore')) {
            // When the "Show more" button is clicked, the first hidden facet option
            // is focused on.
            let $firstHiddenItem = _getFirstHiddenFacetOption($parentFacetList);
            $currentFacetItemElement.click();

            _updateFocus($firstHiddenItem || $parentFacetList);
        } else if ($currentFacetItemElement.is('.facetShowLess')) {
            // When the "Show less" button is clicked, focus passes to the listbox
            $currentFacetItemElement.click();
            currentOptionIndex = (typeof parentFacetItem !== 'undefined') ? parentFacetItem.id : -1;
            _updateFocus($parentFacetList);
        } else if ($currentFacetItemElement.is('a')) {
            $currentFacetItemElement.click();
        } else {
            _updateFocus($currentFacetItemElement.find('.js-availability-label'));
        }
    }

    function _handleSpaceKeyForFacetList(facetObjList) {
        let currentFacetItem = _getFacetItemById(facetObjList, currentOptionIndex);

        if (!currentFacetItem) {
            return
        };

        let $currentFacetItemElement = currentFacetItem.element;

        var $checkbox = $currentFacetItemElement.find('input[type="checkbox"]');

        if (!$checkbox.length) {
            var $parentLiItem = $currentFacetItemElement.closest('.js-taxonomy-child-list-item');
            $checkbox = $parentLiItem.find('input[type="checkbox"]').first();
        }

        if ($checkbox.length) {
            $checkbox.click();

            // For most checkbox facets it refreshes the page/performs an ajax call
            // so when the markup reloads it's checked.  However, for the publication date
            // checkboxes there is no refresh, so we need to manually update the aria-selected
            // in this case.
            if ($checkbox.is(':checked')) {
                $checkbox.attr('aria-selected', true);
            } else {
                $checkbox.attr('aria-selected', false);
            }
        }
    }

    function _getFocusableElement($element) {
        let $label = $element.find('.js-availability-label,.js-pub-label,.js-focus-element');
        if ($label.length) {
            return $label;
        }

        // Handles the show more less buttons and taxonomy links
        if ($element.is('button, a, label')) {
            return $element;
        }

        let $checkbox = $element.find('input[type="checkbox"]');
        if ($checkbox.length) {
            return $checkbox;
        }
    }

    // Retrieves the first hidden facet option in a list box
    // in order to pass focus to it if we've clicked the "Show more"
    // button.
    function _getFirstHiddenFacetOption($parentFacetList) {
        // Determine if the list is filtered or not
        var filtered = $parentFacetList.find('.highlighted').length !== 0;
        var classToFind = filtered ? 'li.highlighted:hidden' : 'li:hidden';

        let $hiddenFacetOptions = $parentFacetList.children(classToFind);
        let $hiddenElementLabel;

        if (!$hiddenFacetOptions.length) {
            let $parentLiItem = $parentFacetList.closest('.js-taxonomy-child-list-item');
            if ($parentLiItem.length) {
                let $facetList = $parentLiItem.find('ul.js-taxonomy-child-list');

                // Determine if the list is filtered or not
                filtered = $facetList.find('.highlighted').length !== 0;
                classToFind = filtered ? 'li.highlighted:hidden' : 'li:hidden';

                $hiddenFacetOptions = $facetList.children(classToFind);
                $hiddenElementLabel = $hiddenFacetOptions.first().find('.js-focus-element');
            }
        } else {
            $hiddenElementLabel = $hiddenFacetOptions.first().find('.js-focus-element');
        }

        return $hiddenElementLabel;
    }

    // Sets focus on the current element the user has navigated to
    function _updateFocus($element) {
            $element.attr('tabindex', 0);
        $element.focus();
    }

    // Determines the next index in the facet option list to pass focus to
    // depending on the direction we're going in the list.
    // ArrowDown = "forward"
    // ArrowUp = "backward"
    function _getCurrentOptionIndexForFacetList(facetTree, index, direction) {
        let newIndex = 0;
        if (direction === 'forward') {
            newIndex = (index < facetTree.length - 1) ? index + 1 : (facetTree.length - 1);
        } else {
            newIndex = (index > 0) ? index - 1 : 0;
        }
        return newIndex;
    }

    // Retrieves the facet item by its id from the list object
    // that holds all the items for a given facet group
    function _getFacetItemById(facetObjList, id) {
        // Find the facet item based on its 'id' property.
        let currentFacetItem = $.grep(facetObjList, function (obj) {
            return obj.id === id;
        })[0];

        return currentFacetItem;
    }

})(jQuery);